import { onMounted, nextTick } from "#imports";

export function useMenuScroller(scrollAmount = 300): {
  initScroller: (container: HTMLElement) => void;
  setupScrollers: () => void;
} {
  const initScroller = (container: HTMLElement): void => {
    if (!container) return;
    const nav = container.closest("nav");
    // console.log(nav);
    if (!nav) return;

    const scrollLeftBtn = nav.querySelector(
      "[data-scroll-left]"
    ) as HTMLElement;
    const scrollRightBtn = nav.querySelector(
      "[data-scroll-right]"
    ) as HTMLElement;
    if (!scrollLeftBtn || !scrollRightBtn) return;

    const checkScroll = (): void => {
      scrollLeftBtn.classList.toggle("hidden", container.scrollLeft <= 0);
      const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
      const isAtEnd =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 1;
      scrollRightBtn.classList.toggle(
        "hidden",
        !hasHorizontalScroll || isAtEnd
      );
    };

    const bindEvents = (): void => {
      scrollLeftBtn.addEventListener("click", () => {
        container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });

      scrollRightBtn.addEventListener("click", () => {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });

      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    };

    checkScroll();
    bindEvents();
  };

  const setupScrollers = (): void => {
    const containers = document.querySelectorAll<HTMLElement>(
      "[data-menu-scroller]"
    );
    for (const container of containers) {
      initScroller(container);
    }
  };

  onMounted(() => {
    nextTick(() => {
      setupScrollers();
    });
  });

  return {
    initScroller,
    setupScrollers,
  };
}
